import React, { useEffect } from 'react';
import MaterialTable from 'material-table';
import { forwardRef } from 'react';
import AddBox from '@material-ui/icons/AddBox';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';
import { makeStyles } from '@material-ui/core/styles';
import { NavLink } from 'react-router-dom';
import CircularProgress from '@material-ui/core/CircularProgress';
import { TablePagination } from '@material-ui/core';
import Cookies from 'js-cookie';
import { faTimes} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import API_PATH from "../../constants/config.json";
const axios = require('axios');
const API_URL = process.env.REACT_APP_BASE_URL;

//Start css code
const useStyles = makeStyles((theme) => ({
  filterTable: {
    width:'100%',
    float:'left',
    position:'relative',
    '& .MuiTableCell-head': {
      fontWeight: '600',
      fontSize: '14pt',
      background: '#fff',
      color: '#000',
      border: '1px solid #d1d1d1',
      padding: '5px',
    },
    '& tr:nth-child(odd)': {
      backgroundColor: '#f2f2f2'
    },
    '& td': {
      padding: '5px',      
      border: '1px solid #D7D7D7',
      '@media only screen and (max-width: 3500px)': {
        fontSize: '12pt !important',
      },
      '@media only screen and (min-width: 3501px)': {
        fontSize: '24pt !important',
      },
    },
    '& th': {
      '@media only screen and (max-width: 3500px)': {
        fontSize: '12pt !important',
        padding: '5px !important',
      },
      '@media only screen and (min-width: 3501px)': {
        fontSize: '24pt !important',
        padding: '15px 5px 10px !important',
      },
    },
    '& td:first-child': {
      color: '#CC0000 !important',
      fontWeight: '600 !important',
    },
    '& table': {
      borderRight: '1px solid #d1d1d1',
    },
    '& .MuiToolbar-regular': {
      minHeight: 'auto',
    },
    '& .MuiTableCell-head:nth-child(2)': {
      textAlign: 'left',
    },
    '& .MuiTableCell-body:nth-child(2)': {
      textAlign: 'left',
    },
    '& .MuiTablePagination-select': {
      color: '#000',
    }
  },
  tdLink: {
    color: '#24618E',
  }
}));
//End css code ..

const tableIcons = {
  Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
  Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
  Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
  DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
  Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
  Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
  FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
  LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
  NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
  ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
  SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
  ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
  ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />)
};

//Start NewUsers component code ...
const NewUsers = props => {
  const classes = useStyles();
  const [newUserList, setNewUserList] = React.useState([]);
  const [pagination, setPagnation] = React.useState({ selectedPage: 1 });
  const [totalItems, setTotalItems] = React.useState(0);
  const [userAccess, setUserAccess] = React.useState(true);
  const [getLoader,setLoaderDisable] = React.useState(false);

  const enteriesPerPage = 10;
  let values = {
    "pageNo": pagination.selectedPage,
    "entriesPerPage": enteriesPerPage,
  }

  useEffect(
    () => {
      getNewUsersAPI();
    }, []
  )

//This method is use for get all new users information for table data ... start
  const getNewUsersAPI = (page = 1) => {
    setLoaderDisable(true);
    try {
      axios({
        method: 'post',
        data: {          
          pageNo: page,//pagination.selectedPage,
          entriesPerPage: enteriesPerPage
        },
        headers: {
          'payload':Cookies.get('payload'),
          'agencyid':sessionStorage.getItem('agency_id')
        },
        url: API_URL + API_PATH.getAllNewUsersAPI,
      })
        .then(async function (response) {
          if (response.status && response.status == '200') {
            setLoaderDisable(false);
            setNewUserList(response.data.data.rows);
            setTotalItems(response.data.data.count);
          } else {
            setLoaderDisable(false);
            setNewUserList([]);
          }

        })
        .catch(function (error) {
          if (error.response) {
            if(error.response.data.status == 403) {
            setLoaderDisable(false);
              setUserAccess(false);
              setNewUserList([]);
            } else {
              setNewUserList([]);
            setLoaderDisable(false);
            }
          } else {
            setNewUserList([]);
            setLoaderDisable(false);
          }
        })
    } catch (error) {
      setLoaderDisable(false);
      console.error(error);
    }
  }
  //This method is use for get all new users information for table data ... end

  const handleSelected = (e, selectedPage) => {
    values.pageNo = selectedPage + 1;
    let page = values.pageNo
    setPagnation({ selectedPage: selectedPage + 1 })
    getNewUsersAPI(page);
  }
  
  return (
    newUserList.length > 0 ?
      <div className={classes.filterTable} data-testid="new_user_table">
      <h5>New Users</h5>
      <MaterialTable
        icons={tableIcons}
        title=""
        columns={[
          {
            title: '', field: 'new', cellStyle: {
              width: '6%',
              textAlign: 'center',
            },
            render: rowData => <div>{'NEW'}</div>,
            headerStyle: {
              width: '6%',
            }
          },
          { title: 'Name', field: 'first_name',
          render: rowData => <NavLink to="#" className={classes.tdLink} onClick={()=>{props.updateUD(rowData.user_id)}}>{rowData.first_name+' '+rowData.last_name}</NavLink>, },
          { title: 'Email', field: 'email' },
          { title: 'Organization', field: 'organization' },

        ]}
        data={newUserList ? newUserList : []}
        totalCount={totalItems}
        options={{
          filtering: false,
          sorting: false,
          // paging: true,
          paging: totalItems > 10 ? true : false,
          pageSize: 10,
          pageSizeOptions: [0],
          search:false,
          emptyRowsWhenPaging: false,
        }}
        // components={
        //   userAccess == true ?
        //   {
        //     Pagination: props => (
        //       <TablePagination
        //         {...props}
        //         count={totalItems}
        //         page={pagination.selectedPage - 1}
        //         onChangePage={handleSelected}
        //         rowsPerPage={enteriesPerPage}
        //       />
        //     )
        //   } : {
        //     Pagination: props => (
        //       <TablePagination
        //         {...props}
        //         count={totalItems}
        //         page={pagination.selectedPage - 1}
        //         onChangePage={handleSelected}
        //         rowsPerPage={enteriesPerPage}
        //       />
        //     ),
        //     Body: (props) => (
        //       <tr class="MuiTableRow-root" style={{height:' 49px'}}><td class="MuiTableCell-root MuiTableCell-body" colspan="4" style={{paddingTop: '0px', paddingBottom: '0px', textAlign: 'center'}}><FontAwesomeIcon icon={faTimes}/> Access Forbidden</td></tr>
        //     )
        //   }
        // }
        components={
          userAccess == true ?
          // newUserList.length > 0 ?
          getLoader == false?
          {
              Pagination: props => (
                <TablePagination
                  {...props}
                  count={totalItems}
                  page={pagination.selectedPage - 1}
                  onChangePage={handleSelected}
                  rowsPerPage={enteriesPerPage}
                />
              ),
            }
            :
            {
                Pagination: props => (
                  <TablePagination
                    {...props}
                    count={totalItems}
                    page={pagination.selectedPage - 1}
                    onChangePage={handleSelected}
                    rowsPerPage={enteriesPerPage}
                  />
                ),
                Body: (props) => (
                  <tbody><tr style={{ height: '49px' }}><td colspan="4" style={{ paddingTop: '0px', paddingBottom: '0px', textAlign: 'center' }}><span style={{ color: '#CC0000', fontWeight: '600' }}><CircularProgress/></span> </td></tr></tbody>
                )
              }
          : {
              Pagination: props => (
                <TablePagination
                  {...props}
                  count={totalItems}
                  page={pagination.selectedPage - 1}
                  onChangePage={handleSelected}
                  rowsPerPage={enteriesPerPage}
                />
              ),
              Body: (props) => (
                <tbody><tr style={{ height: '49px' }}><td colspan="4" style={{ paddingTop: '0px', paddingBottom: '0px', textAlign: 'center' }}><span style={{ color: '#CC0000', fontWeight: '600' }}><FontAwesomeIcon icon={faTimes} /> Access Forbidden</span> </td></tr></tbody>
              )
            }
        }
      />

    </div>
    : null    
  );
}

export default NewUsers;
//End NewUsers component code ...